import { useState, useEffect } from "react";
import "./Vertices.css";
import { Input, Segment, Message, Radio, Select, Loader } from "semantic-ui-react";
import { getVerticesFromFile } from "./getVerticesFromFile";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../store/configureStore";
import { TimestampsStringDict } from "../../../../../store/timestampsReducer";
import {
    SetVertexSelection,
    SetVertices,
    SetVerticesMode,
} from "../../../../../actions/verticesActions";
import { verticesSelectionOptions } from "../../../../../store/verticesReducer";
import {
    ivaEquationOptions,
    ivaSelectionOptions,
    vRefOptions,
} from "../../../../../store/ccValidationReducer";
import {
    SetCCAbsolute,
    SetCCRelative,
    SetCCVRefOption,
    SetIvaEquation,
    SetIvaSelection,
    SetScaleByLoad,
    SetWeightDistance,
} from "../../../../../actions/ccValidationActions";
import { FileDropzone } from "../../../../Dropzone/FileDropzone";
import { SetCsvFile, SetCsvMessage, SetZipFile } from "../../../../../actions/filesActions";
import { HideToastMessage } from "../../../../../actions/toastActions";
import JSZip from "jszip";

/*
export const Vertices = () => {
*/
export const Vertices: React.FC<{ hidden?: boolean }> = ({ hidden }) => {
    const dispatch = useDispatch();
    const zipFile = useSelector((state: AppState) => state.files.zipFile);
    const { csvFile, csvMessage } = useSelector((state: AppState) => state.files);
    const activeTimestamps = useSelector((state: AppState) => state.timestamps.timestamps);
    const availableTimestampsOrScenarios = useSelector((state: AppState) => state.validationProcess.availableTimestampsOrScenarios)
    const vertices = useSelector((state: AppState) => state.vertices.vertices);
    const verticesMode = useSelector((state: AppState) => state.vertices.verticesMode);
    const vertexSelection = useSelector((state: AppState) => state.vertices.vertexSelection);
    const ccValidation = useSelector((state: AppState) => state.ccValidation);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleVerticesMode = () => {
        verticesMode === "automatic"
            ? dispatch(SetVerticesMode("manual"))
            : dispatch(SetVerticesMode("automatic"));
        dispatch(SetVertexSelection(-1));
    };

    const handleSetVertices = (timestamp: number, e: any) => {
        const newVertices = { ...vertices };
        newVertices[timestamp] = e.target.value;
        dispatch(SetVertices({ ...newVertices }));
    };

    const handleSetCsvFile = (file: File) => {
        dispatch(SetCsvFile(file));
        dispatch(HideToastMessage());
        dispatch(SetCsvMessage(file.name));
    };

    useEffect(() => {
        if (vertexSelection === 3) {
            dispatch(SetVertexSelection(-1));
            setMessage("This option is not yet available, please select a different option");
        } else if (vertexSelection === 1 || vertexSelection === 2) setMessage("");
    }, [vertexSelection, dispatch]);

    useEffect(() => {
        if (zipFile && verticesMode === "manual" && availableTimestampsOrScenarios.length > 0) {
            setLoading(true);
            getVerticesFromFile(zipFile).then(res => {
                if (res.length > 0) {
                    const verticesArray = res.split("\n");
                    const newVertices: TimestampsStringDict = {};

                    verticesArray.forEach(line => {
                        let key = "";
                        let value = "";
                        //standard values in VERTICES_MAP.csv: 7;10,211,304
                        const defaultVerticesMapDelimited = line.split(";");
                        //found in some examples: 7,"640, 1691, 1336, 592"
                        const backupVerticesMapDelimited = line.split(',"');
                        if (defaultVerticesMapDelimited.length === 2) {
                            key = defaultVerticesMapDelimited[0];
                            value = defaultVerticesMapDelimited[1];
                        }
                        else if (backupVerticesMapDelimited.length === 2) {
                            key = backupVerticesMapDelimited[0];
                            value = backupVerticesMapDelimited[1]?.replace('"', '');
                        }
                        /*
                        const key = line.split(";")[0];
                        const string = line.split(";")[1];
                        */
                        if (key && value) {
                            //use activeTimestamps to refresh values when changing selected timestamps
                            const ts = availableTimestampsOrScenarios.find(e => e.verticesmapkey === key);
                            if (ts) {
                                newVertices[ts.key] = value;
                            }
                            //hack, we will set 2a value for hour 2, and 2b for hour 222; 25h timestamp
                            else if (key === "2a") {
                                newVertices[2] = value;
                            }
                            else if (key === "2b") {
                                newVertices[222] = value;
                            }
                        }
                    });
                    dispatch(SetVertices({ ...newVertices }));
                }
                setLoading(false);
            });
        }
    }, [zipFile, verticesMode, availableTimestampsOrScenarios, dispatch]);

    const getCsvFile = async (zip: JSZip) => {
        let filename: string | undefined;
        filename = Object.keys(zip.files).find(f => f.endsWith(".csv"));
        if (!filename) return [undefined, undefined];

        const csvContent = await zip.file(filename)?.async("string");
        return [filename, csvContent];
    };

    useEffect(() => {
        if (!(zipFile && csvFile)) return;
        const putCsvIntoZip = async () => {
            const zip = await JSZip.loadAsync(zipFile);
            const [oldFilename, oldContent] = await getCsvFile(zip);

            const newContent = await csvFile.text();
            if (oldContent === newContent && oldFilename === csvFile.name) return;
            if (!(csvFile.name && newContent)) return;

            if (oldFilename) zip.remove(oldFilename);
            zip.file(csvFile.name, newContent);
            dispatch(SetZipFile(new File([await zip.generateAsync({ type: "blob" }) as BlobPart], zipFile.name)));
        };
        putCsvIntoZip();
    }, [zipFile, csvFile, dispatch]);

    if (hidden) {
        return (
            <div></div>
        );
    }
    return (
        <div id="div-vertices-a" className="vertices-container transition-container">
            <Segment id="segment-vertices-c">
                <div id="div-vertices-b" className="vertices-cc-validation">
                    <div id="div-vertices-c" className="cc-validation-input">
                        <p id="p-vertices-setVref">Set Vref </p>
                        <Select
                            id="select-vertices-a"
                            value={ccValidation.vRefOption}
                            options={vRefOptions}
                            onChange={(e, data: any) => dispatch(SetCCVRefOption(data.value))}
                        />
                    </div>
                    <div id="div-vertices-d" className="cc-validation-input">
                        <p id="p-vertices-setAbsolute">Set absolute [MW]</p>
                        <Input
                            id="input-vertices-a"
                            name="absolute"
                            pattern="^-?[0-9]\d*\.?\d*$"
                            className="text-input"
                            type="tel"
                            value={ccValidation.absolute}
                            onChange={(e: any) => dispatch(SetCCAbsolute(e.target.value))}
                        />
                    </div>
                    <div id="div-vertices-e" className="cc-validation-input">
                        <p id="p-vertices-setRelative">Set relative [% of Vi]</p>
                        <Input
                            id="input-vertices-b"
                            name="relative"
                            className="text-input"
                            type="number"
                            min={1}
                            max={50}
                            value={ccValidation.relative}
                            onChange={(e: any) => dispatch(SetCCRelative(e.target.value))}
                        />
                    </div>
                    <div id="div-vertices-f" className="cc-validation-input">
                        <p id="p-vertices-setIVAselection">Set IVA selection</p>
                        <Select
                            id="select-vertices-b"
                            value={ccValidation.ivaSelection}
                            options={ivaSelectionOptions}
                            onChange={(e, data: any) => dispatch(SetIvaSelection(data.value))}
                        />
                    </div>
                    <div id="div-vertices-g" className="cc-validation-input iva-equation">
                        <p id="p-vertices-setIVAcalculation">Set IVA calculation equation</p>
                        <Select
                            id="select-vertices-c"
                            value={ccValidation.ivaEquation}
                            options={ivaEquationOptions}
                            onChange={(e, data: any) => dispatch(SetIvaEquation(data.value))}
                        />
                    </div>
                </div>
                <div id="div-vertices-h" className="vertices-mode-selector">
                    <p id="p-vertices-manualMode">Manual mode</p>
                    <Radio
                        name="verticesMode"
                        slider
                        onChange={handleVerticesMode}
                        checked={verticesMode === "automatic"}
                    />
                    <p id="p-vertices-automaticMode">Automatic mode</p>
                </div>
                <div id="vertices-lower-part" className="vertices-lower-part">
                    {verticesMode === "automatic" ? (
                        <div id="div-vertices-i" className="vertices-selector">
                            <p id="p-vertices-selectionProcedure">Select vertices selection procedure</p>
                            <Select
                                id="select-vertices-e"
                                selectOnBlur={false}
                                value={vertexSelection}
                                options={verticesSelectionOptions}
                                onChange={(e, data: any) => dispatch(SetVertexSelection(data.value))}
                            />
                            {message.length > 0 && (
                                <Message id="message-vertices-e" compact size="small">
                                    {message}
                                </Message>
                            )}
                        </div>
                    ) : (
                        <div id="div-vertices-j">
                            <p id="p-vertices-integers">
                                Set vertices (enter IDs separated by comma). Vertices should be integers
                                greater than 0
                            </p>
                            {loading ? (
                                <Loader id="loader-vertices-e" active inline />
                            ) : activeTimestamps.length > 0 ? (
                                activeTimestamps.map(t => (
                                    <div id={`div-vertices-n-${t}`} className="timestamp-vertices-input" key={t.key}>
                                        {/*
                                    <span id={`span-vertices-n-${t}`} >{String(t).padStart(2, "0")}:30</span>
                                        */}
                                        <span id={`span-vertices-n-${t.key}`} >{t.text}</span>
                                        <Input
                                            id={`input-vertices-n-${t.key}`}
                                            name="vertices"
                                            className="text-input"
                                            type="text"
                                            /*
                                            value={vertices[t] ? vertices[t] : ""}
                                            onChange={handleSetVertices.bind(null, t)}
                                            */
                                             value={vertices[t.key] ? vertices[t.key] : ""}
                                             onChange={handleSetVertices.bind(null, t.key)}
                                        />
                                        <span id={`span-vertices-o-${t}`} >
                                            {/*
                                            !vertices[t] || vertices[t].length === 0
                                            */
                                            !vertices[t.key] || vertices[t.key].length === 0
                                                ? "Please enter at least one vertex!"
                                                : ""}
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <Message id="message-vertices-pleaseSelect" compact size="small">
                                    Please select at least one timestamp
                                </Message>
                            )}
                        </div>
                    )}
                    {/* Show only when procedure is: Closest vertex to the RefProg */}
                    {vertexSelection === 0 && verticesMode === "automatic" &&
                        <>
                            <div id="vertex-distance-sliders">
                                <div id="div-scaling-vertex-distance-by-loads" className="vertices-mode-selector">
                                    <p id="p-scaling-vertex-distance-by-loads">Scaling vertex distance by loads</p>
                                    <Radio
                                        name="scaling-vertex-distance-by-loads"
                                        slider
                                        checked={ccValidation.scaleByLoad}
                                        onChange={() => dispatch(SetScaleByLoad(!ccValidation.scaleByLoad))} />
                                </div>
                                <div id="div-weighting-vertex-distance" className="vertices-mode-selector">
                                    <p id="p-weighting-vertex-distance">Weighting vertex distance</p>
                                    <Radio
                                        name="weighting-vertex-distance"
                                        slider
                                        checked={ccValidation.weightDistance}
                                        onChange={() => dispatch(SetWeightDistance(!ccValidation.weightDistance))} />
                                </div>
                            </div>
                            {ccValidation.weightDistance &&
                                <div id="file-dropzone-vertices" className="file-dropzone">
                                    <div id="dropzone-message-vertices" className="dropzone-message-status">
                                        <p id="p-vertices-message">
                                            Upload weighting factors
                                        </p>
                                    </div>
                                    <FileDropzone essential="fileDropzone-vertices" handleSetFile={handleSetCsvFile} msg={csvMessage} accept={{ "text/csv": [".csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"] }} />
                                </div>
                            }
                        </>
                    }
                </div>
            </Segment>
        </div>
    );
};
